module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C182",
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("— One —")]), _vm._v(" "), _c('p', {
    staticClass: "C168"
  }, [_vm._v("Burying Day")]), _vm._v(" "), _c('p', {
    staticClass: "C251"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "auto",
      "src": "Images/image00247.jpeg",
      "width": "40%"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "C144"
  }, [_vm._v("The farmyard was full of the light of a summer noonday. Not a living creature was to be seen in all the square enclosure, though barns and stables formed the greater part of it, while one end was occupied by a house. Through the gate at the other end, far off in fenced fields might be seen the dark forms of cattle."), _c('span', {
    attrs: {
      "href": "#/Text/part0091#istar1",
      "id": "star1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" And on a road nearer by, a cart crawled along, drawn by one sleepy horse. An occasional weary low came from some imprisoned cow, or animal of the cow-kind, but not even a cat crossed the yard. The door of the empty barn was open and through the opposite doorway shone the last year’s ricks of corn, "), _c('span', {
    attrs: {
      "href": "#/Text/part0091#id_27",
      "id": "id_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" standing golden in the sun.")]), _vm._v(" "), _c('p', {
    staticClass: "C144"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _vm._v("Although a farmyard is not, either in Scotland or elsewhere, the liveliest of places about noon in the summer, there was a peculiar cause rendering this one, at this moment, exceptionally deserted and dreary. There were, however, a great many more people about the place than usual. But they were all gathered in the nicest room of the house—a room of tolerable size, with a clean boarded floor, a mahogany table black with age, and chairs with high straight backs. Every one of these chairs was occupied by a silent man whose gaze was either fixed on the floor or lost in the voids of space. Most were clothed in black from head to foot and each wore a black coat. Their hard, thick, brown hands—hands evidently unused to idleness—grasped their knees or, folded in each other, rested upon them. Some bottles and glasses, with a plate of biscuits, on a table in a corner seemed to indicate that the meeting was not entirely for business purposes. Yet there were no signs of any sort of enjoyment. Nor was there a woman to be seen in the company.")]), _vm._v(" "), _c('p', {
    staticClass: "C144"
  }, [_vm._v("Suddenly a man appeared at the open door whose shirtsleeves showed very white against his other clothing, which, like that of the rest, was black.")]), _vm._v(" "), _c('p', {
    staticClass: "C144"
  }, [_vm._v("“If any of ye want to see the corpse, noo’s yer time,” he said to the assembly.")]), _vm._v(" "), _c('p', {
    staticClass: "C144"
  }, [_vm._v("No one responded to his offer. With a slight air of discomfiture, for he was a busy man and liked bustle, the carpenter turned on his heel and re-ascended the narrow stairs to the upper room where the corpse lay waiting for its final dismissal.")]), _vm._v(" "), _c('p', {
    staticClass: "C144"
  }, [_vm._v("“I reckon they’ve all seen him afore,” he remarked as he rejoined his companion. “Poor fellow! He’s sure some worn. There’ll be no muckle of "), _c('em', [_vm._v("him")]), _vm._v(" to rise again.”")]), _vm._v(" "), _c('p', {
    staticClass: "C144"
  }, [_vm._v("“George, man, dinna jeest i’ the face o’ a corp,” returned the other. “Ye kenna whan yer ain turn may come.”")]), _vm._v(" "), _c('p', {
    staticClass: "C144"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _vm._v("“It’s no disrespeck to the deid, Thamas. That ye ken weel eneuch. I was only pityin’ the worn face of him, leukin up there atween the buirds, as gien he had gotten what he wanted sae lang, and was thankin’ heaven for that same. I jist dinna like to pit the lid ower him.”")]), _vm._v(" "), _c('p', {
    staticClass: "C144"
  }, [_vm._v("“Hoot! hoot! Lat the Lord luik efter his ain. The lid of the coffin disna hide frae his een.” "), _c('span', {
    attrs: {
      "href": "#/Text/part0091#id_29",
      "id": "id_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "C144"
  }, [_vm._v("The last speaker was a stout, broad-shouldered man, a stonemason by trade, powerful and somewhat asthmatic. He was regarded in the neighbourhood as a very religious man, but was more respected than liked because his forte was rebuke.")]), _vm._v(" "), _c('p', {
    staticClass: "C144"
  }, [_vm._v("Together they lifted the last covering of the dead, laid it over him, and fastened it down. And now there was darkness about the dead. But he knew it not, because he was full of light. For this man was one who all his life had striven to be better.")]), _vm._v(" "), _c('p', {
    staticClass: "C144"
  }, [_vm._v("Meantime, the clergyman having arrived, the usual religious ceremonial of a Scottish funeral—the reading of the Word and prayer—was going on below.")]), _vm._v(" "), _c('p', {
    staticClass: "C144"
  }, [_vm._v("“The minister’s come, Thomas,” said the carpenter.")]), _vm._v(" "), _c('p', {
    staticClass: "C144"
  }, [_vm._v("“Come or gang,” said Thomas, “it’s muckle the same. The word itsel’ oot of his mou’ fa’s as deid as chaff upo’ clay. Honest Jeames there’ll rise ance mair, but never a word that man says, wi’ the croon of ’s heid i’ the how of ’s neck, ’ll rise to beir witness of his ministrations.”")]), _vm._v(" "), _c('p', {
    staticClass: "C144"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v("“Hoot, Thamas! It’s no for the likes of me to flee i’ your face—but jist say a fair word for the livin’ ower the deid, ye ken.”")]), _vm._v(" "), _c('p', {
    staticClass: "C144"
  }, [_vm._v("“Na, na. It’s fair words maks foul wark, and the wrath of the Almichty maun purge this toon or a’ be dune. There’s a heap of graceless gaeins on in’t, and that puir feckless body, the minister, never gies a pu’ at the bridle of salvation, to haud them aff of the scaur of hell.” "), _c('span', {
    attrs: {
      "href": "#/Text/part0091#id_31",
      "id": "id_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "C144"
  }, [_vm._v("The stonemason generally spoke of the Almighty as if he were in a state of restrained indignation at the wrongs he endured from his children. If Thomas was right in this, then certainly he himself was one of his offspring. If he was wrong, then there was much well worth his unlearning.")]), _vm._v(" "), _c('p', {
    staticClass: "C144"
  }, [_vm._v("When the prayer was over, the company again seated themselves, waiting till the coffin, now descending the stairs, should be placed in the hearse, which stood at the door. One after another slowly rose and withdrew to the door, watched in silence, and at last fell in behind the body and moved in an irregular procession from the yard. They were joined by several more men in gigs and on horseback. And thus they crept, a curious train, away toward the resting place of the dead.")]), _vm._v(" "), _c('p', {
    staticClass: "C144"
  }, [_vm._v("It would be a dreary rest, indeed, if that were their resting place—on the side of a low hill, without tree or shrub to beautify it, or even the presence of an old church to seem to sanctify the spot. There was some long grass in it, though, climbing up as if it sought "), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("to bury the gravestones in their turn. And that long grass was a blessing. Better still, there was a sky overhead, in which men cannot set up any gravestones.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b9bc8dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/part0010.vue
// module id = 90
// module chunks = 0